import axios from "axios";
import { shouldFetch } from "common/fetchHelpers";
import { acceptHMRUpdate, defineStore } from "pinia";
import { reactive, ref } from "vue";
import { useUserStore } from "store/modules/userStore.js";

export const useFeaturesStore = defineStore("features", () => {
  // User Store
  const userStore = useUserStore();
  const { resetUnreadFeaturesCount } = userStore;

  const features = ref([]);

  const isFetching = reactive({
    features: false,
  });

  const hasFetched = reactive({
    features: false,
  });

  const fetchFeatures = async ({
    forceFetch = false,
    pagination = {},
  } = {}) => {
    if (isFetching["features"]) {
      return isFetching["features"];
    }

    if (!shouldFetch(hasFetched["features"]) && !forceFetch) {
      return { data: features.value || [], meta: pagination };
    }

    isFetching["features"] = (async () => {
      try {
        const { page = 1, per_page = 1 } = pagination;

        const { data } = await axios.get(`api/update`, {
          params: { page, per_page },
        });

        hasFetched["features"] = new Date();

        resetUnreadFeaturesCount();

        return {
          data: data.data,
          meta: data.meta,
        };
      } finally {
        isFetching["features"] = false;
      }
    })();

    return isFetching["features"];
  };

  return {
    features,
    isFetching,
    hasFetched,
    fetchFeatures,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useFeaturesStore, import.meta.hot));
}
